<template>
  <div class="mt-10">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="text-center">Carton</th>
          <th width="150">Box Number</th>
          <th width="150" class="text-center">Recipient ID</th>
          <th class="text-center">Total</th>
          <th class="text-center">Orders</th>
        </tr>
      </thead>
      <template v-for="carton in cartons">
        <tbody :key="carton.no">
          <tr v-for="(box, boxIndex) in carton.boxes" :key="boxIndex">
            <td class="text-center">{{ carton.no }}</td>
            <td class="text-capitalize">
              {{ box.name.replace(/_/g, " ") }}
              <span v-if="showConsultantId(box.recipientId)">
                - {{ box.recipientId }}</span
              >
            </td>
            <td class="text-center">
              {{ box.recipientType }} - {{ box.recipientId }}
            </td>
            <td class="text-center">{{ box.total }}</td>
            <td>
              <div v-for="(orderIds, orderType, orderIndex) in box.orders" :key="orderIndex"
                   v-if="orderIds.length > 0" class="mb-2">
                <span class="order-type">{{ getProductCategoryLabel(orderType) }} ({{ orderIds.length }})</span> : {{ orderIds.join(", ") }}
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  props: ["cartons"],
  mounted() {
    console.log(this.cartons)
  },
  methods: {
    /**
     * show consultnat Id if more than one box exists in cartons
     * @param int consultantId
     */
    showConsultantId(consultantId) {
      let totalBoxesForInputConsultantId = 0;
      this.cartons.forEach(function (carton) {
        let boxes = carton.boxes.filter(function (box) {
          return box.consultantId == consultantId && box.name != "mixed_box";
        });
        totalBoxesForInputConsultantId += boxes.length;
      });
      return totalBoxesForInputConsultantId > 1;
    },
    /**
     *
     * @param orderType
     * @returns {*}
     */
    getProductCategoryLabel(orderType) {
      let label = orderType
      switch (orderType) {
        case 'shirt':
          label = 'Shirt';
          break;
        case 'kellerfaltenbluse':
          label = 'KFB';
          break;
      }

      return label;
    }
  },
};
</script>

<style>
  .order-type {
    font-weight: bold;
  }
</style>
